//export *     from './graphql'
export * from './constants'
import utils from './utils'

export *     from './activityNodeTypeMapping'
export {utils}

export * from './components'
export * from './services'
export * from './enums'

window['utils'] = utils

export const EMPTY_FUNCTION = () => {}
export * from './react-utils'


// WEBPACK FOOTER //
// ./src/modules/common/index.ts